import {css} from "lit-element/lit-element.js";
export default css`.critical-action-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjMjExMjI4NjU4MS9zcmMvcGFja2FnZXMvd2ViY29tcG9uZW50cy9zcmMvY29tcG9uZW50cy9zdHJ1Y3R1cmUvYXRsYXMtY3JpdGljYWwtYWN0aW9uLWxpc3QiLCJzb3VyY2VzIjpbImF0bGFzLWNyaXRpY2FsLWFjdGlvbi1saXN0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuY3JpdGljYWwtYWN0aW9uLWxpc3Qge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBnYXA6IDAuNzVyZW07XG59XG4iXX0= */`;
